import { NavigateFunction } from 'react-router-dom';

let navigateFunction: NavigateFunction | null = null;

/**
 * Configura a função de navegação do React Router
 * Deve ser chamada uma vez na inicialização do app
 */
export function setupNavigationService(navigate: NavigateFunction) {
  navigateFunction = navigate;
}

/**
 * Função segura para navegação que funciona tanto dentro quanto fora do contexto React
 * @param path Caminho para navegar
 * @param options Opções de navegação
 */
export function safeNavigate(path: string, options?: { 
  replace?: boolean;
  preserveQuery?: boolean;
}) {
  // Se estamos fora do contexto React (ex: em um utilitário)
  if (!navigateFunction) {
    const finalPath = options?.preserveQuery 
      ? `${path}${window.location.search}`
      : path;
      
    if (options?.replace) {
      window.location.replace(finalPath);
    } else {
      window.location.href = finalPath;
    }
    return;
  }

  // Se estamos dentro do contexto React
  navigateFunction(path, { replace: options?.replace });
}

/**
 * Função para redirecionar após autenticação
 * @param defaultPath Caminho padrão se não houver redirecionamento específico
 */
export function redirectAfterAuth(defaultPath: string = '/home') {
  const urlParams = new URLSearchParams(window.location.search);
  const redirectUrl = urlParams.get('redirect');
  
  if (redirectUrl) {
    try {
      const decodedUrl = decodeURIComponent(redirectUrl);
      safeNavigate(decodedUrl, { replace: true });
    } catch (error) {
      safeNavigate(defaultPath, { replace: true });
    }
  } else {
    safeNavigate(defaultPath, { replace: true });
  }
}

/**
 * Função para redirecionar com base no estado de autenticação
 * @param isAuthenticated Se o usuário está autenticado
 */
export function handleAuthNavigation(isAuthenticated: boolean) {
  if (isAuthenticated) {
    safeNavigate('/home', { replace: true });
  } else {
    safeNavigate('/auth', { replace: true });
  }
} 